<template>
  <div class="home container" :class="$vuetify.breakpoint.xsOnly ? 'px-0' : ''">
    <background-parallax v-bind:backgroundOpacityProp="'0.6'" />
    <div class="mt-12 pt-12" style="position: relative"></div>
    <v-sheet
      class="mb-12 py-12 box box-rounded box-transparent box-transparent-dark"
      elevation="6"
    >
      <h1 class="page-header display-1 font-weight-medium white--text">
        Vehicle History
      </h1>
    </v-sheet>
    <v-card
      class="box box-rounded box-transparent box-transparent-light"
      elevation="12"
    >
      <v-card-subtitle>
        <v-breadcrumbs class="smc-breadcrumbs">
          <v-breadcrumbs-item class="smc-breadcrumbs-item" to="/">
            <v-icon>mdi-home</v-icon>
          </v-breadcrumbs-item>
          <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
          <v-breadcrumbs-item v-if="isOrganization" class="smc-breadcrumbs-item" to="/active-requests">
            Active Requests
          </v-breadcrumbs-item>
          <v-breadcrumbs-item v-else class="smc-breadcrumbs-item" to="/my-garage">
            My Garage
          </v-breadcrumbs-item>
          <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
          <v-breadcrumbs-item class="smc-breadcrumbs-item">
            Vehicle History
          </v-breadcrumbs-item>
        </v-breadcrumbs>
        <div class="sort-container">
          Sort by:
          <v-chip>{{ sortModel.selectedSort.text }}</v-chip>
          <v-hover v-slot:default="{ hover }">
            <v-btn icon @click="invertSort">
              <v-icon :color="hover ? 'primary' : 'default'">
                {{
                  sortModel.dir == "desc"
                    ? "mdi-arrow-down-thick"
                    : "mdi-arrow-up-thick"
                }}
              </v-icon>
            </v-btn>
          </v-hover>
        </div>
      </v-card-subtitle>

      <v-card-text v-if="!loading && vehicleId && !allVehicles" class="py-0 my-n3 text-right">
        <v-btn rounded right color="primary" @click="loadQuoteRequests(true)">
          All history
        </v-btn>
      </v-card-text>

      <v-card-text class="mt-4">
        <div v-if="loading">
          <box-view-skeleton-loader
            v-for="i in [1, 2, 3]"
            v-bind:key="i"
            class="mb-6"
          />
        </div>
        <quote-request-view
          v-for="(item, i) in sortedQuoteRequests"
          v-bind:key="i"
          v-bind:quoteRequestProp="item"
          class="mb-6"
        />
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import _ from "lodash";
import backgroundParallax from "@/components/widgets/background-parallax";
import quoteRequestView from "@/components/quote-request-view";
import boxViewSkeletonLoader from "@/components/widgets/box-view-skeleton-loader";
import { quoteRequestService } from "@/services";

export default {
  name: "quote-requests",
  components: {
    backgroundParallax,
    quoteRequestView,
    boxViewSkeletonLoader,
  },
  props: {
    vehicleId: String,
  },
  data: () => {
    return {
      loading: true,
      allVehicles: false,
      sortModel: {
        dir: "desc",
        selectedSort: { text: "Date submitted", value: "dateCreatedUtc" },
      },
      sortOptions: {
        dateSubmitted: { text: "Date submitted", value: "dateCreatedUtc" },
      },
      quoteRequests: [],
    };
  },
  computed: {
    isOrganization() {
      return this.$store.getters["user/isOrganization"];
    },
    sortedQuoteRequests() {
      var sortedStuff = _.orderBy(
        this.quoteRequests,
        [this.sortModel.selectedSort.value],
        [this.sortModel.dir]
      );
      return sortedStuff;
    },
  },
  async mounted() {
    await this.loadQuoteRequests(false);
  },
  methods: {
    invertSort() {
      if (this.sortModel.dir == "asc") {
        this.sortModel.dir = "desc";
      } else {
        this.sortModel.dir = "asc";
      }
    },
    async loadQuoteRequests(allVehicles) {
      this.loading = true;
      var vehicleId = this.vehicleId ? allVehicles ? 0 : this.vehicleId : 0;
      this.allVehicles = allVehicles;
      this.quoteRequests = await quoteRequestService.getQuoteRequests(vehicleId);
      this.loading = false;
    }
  },
};
</script>

<style scoped>
@import "../assets/scss/vuetify-elements/card.scss";
@import "../assets/scss/vuetify-elements/sheet.scss";

.page-header {
  position: relative;
}

.smc-breadcrumbs {
  padding-left: 12px;
}

.smc-breadcrumbs .smc-breadcrumbs-item {
  font-weight: 600;
}
</style>

<style lang="scss" scoped>
.sort-container {
  text-align: right;

  @media screen and (min-width: 601px) {
    position: absolute;
    right: 16px;
    top: 26px;
  }
}
</style>